import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";

@Component({
  selector: "app-worker-safety",
  templateUrl: "./worker-safety.component.html",
})
export class WorkerSafetyComponent implements OnInit, OnChanges {
  @Input() formTabData: any; // Input property to receive formData from the parent component
  dateFormat = "dd/MM/yyyy";
  currentDate: Date;
  safetyForm: FormGroup;
  trangBiThungSoCapCuOptions: string[] = ["Tại nhà", "Tại vườn", "Không"];
  yesNoOptions: string[] = ["Có", "Không"];
  doBaoHoSuDungOptions: string[] = [
    "Mắt kính",
    "Mặt nạ",
    "Khẩu trang",
    "Áo quần",
    "Ủng",
    "Bao tay",
    "Khác",
  ];
  kienThucDaTrangBiOptions: string[] = [
    "Kỹ thuật ca cao con",
    "Kỹ thuật ca cao trưởng thành",
    "IPM",
    "Bảo tồn đa dạng sinh học",
    "Luật lao động",
    "An Toàn sức khỏe lao động",
  ];
  tanSuatSuDungThuocBVTVOptions: string[] = [
    "Mỗi tuần",
    "Mỗi tháng",
    "Mỗi Quý",
    "Tùy theo điều kiện",
    "Không sử dụng",
  ];
  suDungPhanBonOptions: string[] = [
    "Vô cơ",
    "Hữu cơ",
    "Chế phẩm sinh học",
    "Vôi",
    "Không",
  ];
  constructor(private fb: FormBuilder) {}
  ngOnChanges(changes: SimpleChanges) {
    if (changes.formTabData ) {
      this.buildForm();

      if (this.formTabData && this.formTabData.anToanSucKhoe) {
        const trimmedJsonString = this.formTabData.anToanSucKhoe.trim();
        const workerSafetyData = JSON.parse(trimmedJsonString);

        if (workerSafetyData) {
          this.setFormValues(this.safetyForm, workerSafetyData.safetyForm);
        }
      }
    }

    this.safetyForm
    .get("doBaoHoSuDung").valueChanges.subscribe((selectedOptions) => {
      const isKhacSelected = selectedOptions.includes("Khác");
      if (!isKhacSelected) {
        // Reset the custom input value when 'Khác' is not selected
        this.safetyForm.get("customDoBaoHo").setValue(null);
      }
    })
  }
  private setFormValues(formGroup: FormGroup, data: any): void {
    for (const controlName in data) {
      if (data.hasOwnProperty(controlName)) {
        const control = formGroup.get(controlName);
        if (control) {
          control.setValue(data[controlName]);
        }
      }
    }
  }

  private serializeFormGroup(formGroup: FormGroup): any {
    const serialized = {};
    for (const controlName in formGroup.controls) {
      if (formGroup.controls.hasOwnProperty(controlName)) {
        serialized[controlName] = formGroup.get(controlName).value;
      }
    }
    return serialized;
  }
  submitForm() {
    if (!this.safetyForm.value.trangBiThungSoCapCu || this.safetyForm.value.trangBiThungSoCapCu === '') {
      this.safetyForm.get('ngayGhiNhan').setValue(null);
    }
    const formData = {
      safetyForm: this.serializeFormGroup(this.safetyForm),
    };

    return formData;
  }

  buildForm() {
    this.safetyForm = this.fb.group({
      ngayGhiNhan: [this.currentDate, Validators.required],
      trangBiThungSoCapCu: [null, Validators.required],
      suDungDoBaoHoLaoDong: [null, Validators.required],
      doBaoHoSuDung: [[]],
      customDoBaoHo:[null],
      kienThucDaTrangBi: [[]],
      nguonNuocSachSuDung: [null, Validators.required],
      duNuocSinhHoaTaiNha: [null, Validators.required],
      duDungCuChuaNuoc: [null, Validators.required],
      ghiChuVeDungCuChuaNuoc: [""],
      tanSuatSuDungThuocBVTV: [null, Validators.required],
      suDungThuocHuuCo: [null, Validators.required],
      tenThuocBVTVHuuCo: [""],
      suDungPhanBon: [null, Validators.required],
      suDungBaySinhHoc: [null],
    });
  }
  ngOnInit(): void {
    this.currentDate = new Date();
    this.buildForm();
  }
  getValidationStatus(controlName: string, yourForm: FormGroup): string {
    const control = yourForm.get(controlName);
    return  control.invalid ? 'error' : '';
  }
}
